<template>
  <gh-table-page ref="table" :args-query="argsQuery" module="plat.page" cls="PageCodeService" :before-save="submitCode">
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="argsQuery.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>

    <template #area_edit="{model,props}">
      <v-container grid-list-xs fluid>
        <v-layout column>
          <v-layout row wrap align-center>
            <gh-input :model="model" :prop="getPropType(props,'Type')"></gh-input>
            <gh-input :model="model" :prop="getPropType(props,'Name')"></gh-input>
          </v-layout>

          <gh-code-editor :height="400" ref="codePage" title="前台代码编辑" :show-actions="false" v-model="model.PageCode"
            :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'javascript'}" @submit=''
            @cancel=''>
          </gh-code-editor>
          <gh-code-editor title="后台代码编辑" :show-actions="false" v-model="model.ServiceCode"
            :options="{readOnly: false,autoIndent:true,automaticLayout: true,language:'python'}" @submit='' @cancel=''
            ref="codeService">
          </gh-code-editor>

        </v-layout>



      </v-container>


    </template>

  </gh-table-page>


</template>

<style scoped>

</style>

<script>
  import Page from "./page.ts";
  export default Page;
</script>